import Reveal from '@/components/feature/Reveal';
import { SectionWrapper, SectionHeading } from '@/components/feature/SectionHeading';

interface StoryProps {
  eyebrow: string;
  title: string;
  paragraphs: string[];
  className?: string;
}

export default function Story({ eyebrow, title, paragraphs, className = '' }: StoryProps) {
  return (
    <SectionWrapper className={className}>
      <SectionHeading eyebrow={eyebrow} title={title} />
      <Reveal className="mt-8 md:mt-10 max-w-3xl mx-auto">
        <div className="bg-[#1a1a2e] border border-[#2a2a3e] rounded-3xl p-8 md:p-12">
          {paragraphs.map((p, i) => (
            <p
              key={i}
              className={
                i === 0
                  ? 'text-[#e8e8f0] text-base md:text-lg leading-loose'
                  : 'mt-4 text-[#e8e8f0] text-base md:text-lg leading-loose'
              }
            >
              {p}
            </p>
          ))}
        </div>
      </Reveal>
    </SectionWrapper>
  );
}